module.exports = __webpack_public_path__ + "static/media/field-green.0b4e2e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/field-green.svg
// module id = 44
// module chunks = 0